import { useState } from 'react';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import DealPlanNameHoverButton from './styledComponents/DealPlanNameHoverButton';
import { InlineEditInput } from 'deal-plans-lib/components/milestone/InlineEditInput';
import { useDealPlanActions } from '../hooks/useDealPlanActions';
import { getIsPreview } from '../utils/getIsPreview';
import { jsx as _jsx } from "react/jsx-runtime";
export const DealPlanName = ({
  name,
  dealPlanId,
  isHubSpotUser = true
}) => {
  const isPreview = getIsPreview();
  const canEdit = isHubSpotUser && !isPreview;
  const [isEditingName, setIsEditingName] = useState(false);
  const {
    updateName
  } = useDealPlanActions(dealPlanId, name);
  const handleUpdateName = newName => {
    updateName(newName);
    setIsEditingName(false);
  };
  return /*#__PURE__*/_jsx(Flex, {
    minBlockSize: "32px",
    marginBlockEnd: "400",
    children: isEditingName ? /*#__PURE__*/_jsx(InlineEditInput, {
      value: name,
      onSubmit: handleUpdateName,
      onCancel: () => setIsEditingName(false),
      typography: "heading-500",
      dataTestId: "deal-plan-name-input"
    }) : /*#__PURE__*/_jsx(DealPlanNameHoverButton, {
      "data-test-id": "deal-plan-name-display",
      disabled: !canEdit,
      onClick: canEdit ? () => setIsEditingName(true) : undefined,
      onKeyDown: canEdit ? e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setIsEditingName(true);
        }
      } : undefined,
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-500",
        children: name
      })
    })
  });
};